import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Accuracy_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "IM",
      testMethod: "IS 1350 Part-I",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "VM",
      testMethod: "IS 1350 Part-II",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "VM",
      testMethod: "IS 1350 Part-II",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "VM",
      testMethod: "IS 1350 Part-I",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "IM",
      testMethod: "IS 1350 Part-I",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "VM",
      testMethod: "IS 1350 Part-II",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "VM",
      testMethod: "IS 1350 Part-I",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
    {
      date: "01 Jan 2025",
      testType: "INS101",
      testParameter: "VM",
      testMethod: "IS 1350 Part-I",
      certifiedValue: 24.5,
      obs01: 24.5,
      obs02: 55,
      obs03: 32,
      obs04: 48,
      obs05: 32,
      checkedBy: "Rajesh Kumar",
      average: 0.0103,
      stdDeviation: 0.0103,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowspan="2">
                  <input type="checkbox" />
                </th>
                <th rowspan="2">Date</th>
                <th rowspan="2">Test Type</th>
                <th rowspan="2">Test Parameter</th>
                <th rowspan="2">Test Method</th>
                <th rowspan="2">Certified Value</th>
                <th colspan="5">Observations</th>
                <th rowspan="2">Checked By</th>
                <th rowspan="2">Avg.</th>
                <th rowspan="2">Std Deviation</th>
              </tr>
              <tr>
                <th>OBS 01</th>
                <th>OBS 02</th>
                <th>OBS 03</th>
                <th>OBS 04</th>
                <th>OBS 05</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.testType}</td>
                  <td>{row.testParameter}</td>
                  <td>{row.testMethod}</td>
                  <td>{row.certifiedValue}</td>
                  <td>{row.obs01}</td>
                  <td>{row.obs02}</td>
                  <td>{row.obs03}</td>
                  <td>{row.obs04}</td>
                  <td>{row.obs05}</td>
                  <td>{row.checkedBy}</td>
                  <td>{row.average}</td>
                  <td>{row.stdDeviation}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Accuracy_Report_Table;
